import { createSelector } from 'reselect';

const getUser = (state) => state.user;

const UserSelectors = {
  makeUser: createSelector([getUser], (user) => user),
  makeEmail: createSelector([getUser], (user) => user.email),
};

export default UserSelectors;
